import { createAsyncThunk } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import api from "../../api";

export const GetBanks = createAsyncThunk(
  "ls/GetBanks",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await api.get(`/banks?user_id=${payload}`, payload);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.message || "An error occured");
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetRemittance = createAsyncThunk(
  "ls/GetBanks",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await api.get(`/transactions?payout=true`, payload);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.message || "An error occured");
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const AddBank = createAsyncThunk(
  "ls/GetPayments",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await api.post(`/banks`, payload);
      toast.success(response?.data?.message);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.message || "An error occured");
      return rejectWithValue(error?.response?.data);
    }
  }
);

const initialState = {
  Payments: {},
};

export const PaymentSlice = createSlice({
  name: "Payments",
  initialState,

  extraReducers: (builder) => {
    builder
      .addCase(GetBanks.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(GetBanks.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
          Payments: action.payload,
        };
      })
      .addCase(GetBanks.rejected, (state, action) => {
        return {
          isLoading: false,
          error: action.payload,
        };
      });
  },
});

export default PaymentSlice.reducer;
